import { Switch as _Switch, SwitchProps as _SwitchProps } from 'antd'

type Props = _SwitchProps

export const Switch = (props: Props) => {
  return <_Switch {...props} />
}
